import { useHasPermission } from "@/features/auth/hooks/usePermission";

const useMustHidePickems = () => {
  const canViewContests = useHasPermission("viewContest");

  return !canViewContests;
};

export default useMustHidePickems;
